import React, { useState } from "react";

// MATERIAL UI COMPONENTS
import { StyledTextField } from "../styled/inputs/textInput";

const OrderCodeOrCustomerNameFilter = ({ selectedValue, onFilterChange }) => {
  const [queryString, setQueryString] = useState(null);

  return (
    <StyledTextField
      labelpadding="6px 0"
      size="small"
      id="query_text"
      name="query_text"
      label="Código Pedido/Nome Cliente"
      fullWidth
      autoComplete="given-order-code"
      variant="outlined"
      value={queryString}
      onChange={(event) => {
        setQueryString(event.target.value);
        onFilterChange(event.target.value);
      }}
    />
  );
};

OrderCodeOrCustomerNameFilter.displaynName = "Código Pedido/Nome Cliente";

export default OrderCodeOrCustomerNameFilter;
